import React, {useContext, useState} from "react";
import { StyledCardsList, StyledHeader, StyledPlansContainer } from "./plans.style";
import PlanCard from "./PlanCard.component";
import Spinner from "../utils/LoadingSpinner";
import plansList from "./plansList";
import {MidBox} from "../signIn/signin.style";
import FixelDataContext from "../../context/FixelDataContext";

const Plans = () => {
  const { fullFixelData } = useContext(FixelDataContext);
  const [showSpinner, setShowSpinner] = useState(false);
  const isActivePlan = fullFixelData.plan && fullFixelData.plan.state.toLowerCase() === "active";
  const renderPlans = () => {
    if (plansList.length) {
      return plansList.map((plan) => {
        return (
          <li key={plan.id}>
            <PlanCard plan={plan} setShowSpinner={setShowSpinner} />
          </li>
        );
      });
    }
  };
  return (
    <StyledPlansContainer>
      <StyledHeader>
        <h2>Grow Your Business with Fixel</h2>
        <p>Choose the plan that fit your business goals</p>
      </StyledHeader>
      <StyledCardsList>{showSpinner ? <Spinner /> : renderPlans()}</StyledCardsList>
        {isActivePlan &&
            <MidBox>
                If you wish to cancel your plan, please shoot us an email to <a href={"mailto:support@fixel.ai?subject=Plan Cancellation"}>support@fixel.ai</a>, and we'll get back to you as soon as possible
            </MidBox>}
    </StyledPlansContainer>
  );
};
export default Plans;
